import React, { useContext, useState, useRef, useEffect } from "react";
import SlotSlider from "./slider/SlotSlider";
import LiveCashino from "./slider/LiveCashino";
import LayoutNew from "../components/shared/LayoutNew";
import DesktopShell from "../components/shared/DesktopShell";
import { useNavigate } from "react-router-dom";
import { isEmpty } from "lodash";
import AuthContext from "../context/AuthContext";
import BetSlipContext from "../context/BetSlipContext";
import { useTranslation } from "react-i18next";
import CurrentNews from "../components/CurrentNews";
import GameSliderNew from "../components/GameSliderNew";
import FooterSection from "../components/FooterSection";
// import MainBanner from "./slider/MainBanner"; // admin banner — replaced with static /banner.jpg
import HomeCard from "../components/home/HomeCard";
import CasinoGamesSection from "../components/home/CasinoGamesSection";
import HorseRacingSchedule from "../components/home/HorseRacingSchedule";
import HomeList from "../components/home/HomeList";
import {DepositWithrawDataArray} from '../Utils/variables/DepositWithrawDataArray';
import apiPath from "../Utils/apiPath";
import { apiGet, apiGet2 } from "../Utils/apiFetch";
import { setData, getData } from "../Utils/indexedDB";
import InplayTabs from "./Inplay/InplayTabs";
import { IoMdSettings } from "react-icons/io";


const HomeNew = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { user, profileData, setBr, lang, setEn, messagelist, setAnnouncement, amounutRefresh, refreshAmountLoader, userCoins, setSearchToogle, setLoader, setShowMiniCasino, setSettingToogle } =
    useContext(AuthContext);
  const { handelAddMultiMarket } = useContext(BetSlipContext);
  const [show, setShow] = useState(false);

  // Dragging state
  const [isDragging, setIsDragging] = useState(false);
  const [position, setPosition] = useState({ x: window.innerWidth - 80, y: window.innerHeight - 180 }); // Start at bottom right
  const [dragOffset, setDragOffset] = useState({ x: 0, y: 0 });
  const spinnerRef = useRef(null);

  const handleStart = (clientX, clientY) => {
    const rect = spinnerRef.current.getBoundingClientRect();
    setDragOffset({
      x: clientX - rect.left,
      y: clientY - rect.top
    });
    setIsDragging(true);
  };

  const handleMove = (clientX, clientY) => {
    if (!isDragging) return;

    // Ensure the spinner stays within the viewport bounds
    let newX = clientX - dragOffset.x;
    let newY = clientY - dragOffset.y;

    // Keep within viewport
    newX = Math.max(0, Math.min(newX, window.innerWidth - 70));
    newY = Math.max(0, Math.min(newY, window.innerHeight - 70));

    setPosition({
      x: newX,
      y: newY
    });
  };

  const handleEnd = () => {
    setIsDragging(false);
  };

  const handleMouseDown = (e) => {
    e.preventDefault();
    handleStart(e.clientX, e.clientY);
  };

  const handleMouseMove = (e) => {
    handleMove(e.clientX, e.clientY);
  };

  const handleMouseUp = () => {
    handleEnd();
  };

  const handleTouchStart = (e) => {
    e.preventDefault();
    const touch = e.touches[0];
    handleStart(touch.clientX, touch.clientY);
  };

  const handleTouchMove = (e) => {
    e.preventDefault();
    const touch = e.touches[0];
    handleMove(touch.clientX, touch.clientY);
  };

  const handleTouchEnd = () => {
    handleEnd();
  };

  useEffect(() => {
    // Update initial position when window resizes
    const updateInitialPosition = () => {
      setPosition({
        x: window.innerWidth - 80,
        y: window.innerHeight - 80
      });
    };

    window.addEventListener('resize', updateInitialPosition);
    return () => window.removeEventListener('resize', updateInitialPosition);
  }, []);

  useEffect(() => {
    if (isDragging) {
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
      document.addEventListener('touchmove', handleTouchMove, { passive: false });
      document.addEventListener('touchend', handleTouchEnd);

      return () => {
        document.removeEventListener('mousemove', handleMouseMove);
        document.removeEventListener('mouseup', handleMouseUp);
        document.removeEventListener('touchmove', handleTouchMove);
        document.removeEventListener('touchend', handleTouchEnd);
      };
    }
  }, [isDragging, dragOffset]);

  const [tabkey, setTabkey] = useState("homegame");
  const [activeSport, setActiveSport] = useState('Cricket');
  // Which top-nav entry is highlighted. Home page defaults to "Home" even though
  // the center shows Cricket matches — the nav only follows an explicit sport
  // click from the nav bar / sidebar.
  const [navSport, setNavSport] = useState("Home");
  const [sportsData, setSportsData] = useState([]);
  const [isDesktop, setIsDesktop] = useState(() => window.matchMedia("(min-width: 1024px)").matches);
  const [desktopMarkets, setDesktopMarkets] = useState({});

  useEffect(() => {
    const media = window.matchMedia("(min-width: 1024px)");
    const update = () => setIsDesktop(media.matches);
    media.addEventListener("change", update);
    return () => media.removeEventListener("change", update);
  }, []);

  const desktopEventIds = isDesktop
    ? sportsData.filter(item => item.gameType === activeSport?.toLowerCase()).map(item => item.eventId).join(",")
    : "";

  useEffect(() => {
    if (!desktopEventIds) return;
    let cancelled = false;
    let timer;
    const refreshOdds = async () => {
      try {
        const { status, data: response } = await apiGet2(`${apiPath.getMatchOdds}?match_ids=${desktopEventIds}`);
        if (!cancelled && status === 200 && response?.status && Array.isArray(response.data)) {
          const markets = {};
          response.data.forEach(market => {
            markets[`${market.eventId}:${market.marketId}`] = market;
          });
          setDesktopMarkets(markets);
        }
      } catch (error) {
        if (!cancelled) setDesktopMarkets({});
      } finally {
        if (!cancelled) timer = window.setTimeout(refreshOdds, 5000);
      }
    };
    refreshOdds();
    return () => {
      cancelled = true;
      window.clearTimeout(timer);
    };
  }, [desktopEventIds]);

  const selectDesktopSport = (sport) => setActiveSport(sport);
  const openDesktopCasino = () => {
    if (isEmpty(user)) navigate("/login");
    else setShowMiniCasino(true);
  };
  const desktopSports = ["Cricket", "Casino", "Tennis", "Soccer", "Horse Racing", "Greyhound Racing", "Basketball", "Lottery"];
  // Map the desktop nav/sidebar labels to the activeSport value the home filter
  // understands (same keys as sportMap/sportsIdMap below).
  const NAV_TO_ACTIVE = {
    "Cricket": "Cricket",
    "Soccer": "Soccer",
    "Tennis": "Tennis",
    "Basketball": "Basketball",
    "Horse Racing": "Horse",
    "Greyhound Racing": "Greyhound",
  };
  const onDesktopSport = (sport) => {
    if (NAV_TO_ACTIVE[sport]) { selectDesktopSport(NAV_TO_ACTIVE[sport]); setNavSport(sport); }
    else if (["Live Casino", "Casino"].includes(sport)) navigate("/live-casino");
    else if (["Lottery", "Vimaan"].includes(sport)) openDesktopCasino();
    else navigate("/");
  };
  // Top-nav highlight follows an explicit nav/sidebar sport click only; it
  // stays "Home" on initial load (even though the center shows Cricket).
  const desktopActiveNav = navSport;
  // Highlights tabs only cover the three ball-sports; hide them for racing /
  // basketball. Also hide on desktop once a sport is explicitly picked from the
  // nav bar — then only that sport's match list shows (no in-page tabs).
  const showHighlightTabs = ["Cricket", "Soccer", "Tennis"].includes(activeSport) &&
    !(isDesktop && navSport !== "Home");

    const setFunc = (type) => {
      setTabkey(type);
    };

  const getGameType = (eventType) => {
    switch (eventType) {
      case 1: return "soccer";
      case 2: return "tennis";
      case 4: return "cricket";
      case 7: return "horseracing";
      case 4339: return "greyhound";
      case 7522: return "basketball";
      default: return "cricket";
    }
  };

  const transformMatches = (matches) => {
    return matches.map(match => {
      const runners = match.market?.selections
        ? match.market.selections.map(selection => ({
            SelectionId: selection.selectionId,
            RunnerName: selection.runnerName
          }))
        : [];
      return {
        _id: match.id.toString(),
        eventId: match.eventId.toString(),
        centralizedId: match.eventId.toString(),
        eventDateTime: new Date(match.openDateTime).toISOString(),
        eventName: match.name,
        eventType: match.eventType.toString(),
        gameType: getGameType(match.eventType),
        marketCount: match.markets ? match.markets.length : 0,
        marketId: match.market ? match.market.marketId : "",
        seriesId: match.competitionId.toString(),
        seriesName: match.competitionName,
        status: match.isInPlay === 1 ? "in_play" : "upcoming",
        timeZone: match.timezone || "GMT",
        runners,
        desktopSelections: match.market?.selections || [],
        premiumFancy: (match.hasSportsBookMarkets || match.hasOwSportsBookMarkets || match.hasGeniusSportsMarkets) ? "on" : "off",
        bookMaker: (match.hasBookMakerMarkets || match.hasInPlayBookMakerMarkets) ? "on" : "off",
        fancy: (match.hasFancyBetMarkets || match.hasInPlayFancyBetMarkets) ? "on" : "off",
      };
    });
  };

  const fetchAllSport = async () => {
    const now = new Date();
    const todayStr = now.toDateString();
    const tomorrow = new Date(now);
    tomorrow.setDate(tomorrow.getDate() + 1);
    const tomorrowStr = tomorrow.toDateString();

    // Include live matches and scheduled matches for today and tomorrow.
    const filterHomeMatches = (matches) => matches.filter(m => {
      if (m.isInPlay == 1) return true; // include in-play matches
      const matchDay = new Date(m.openDateTime).toDateString();
      return matchDay === todayStr || matchDay === tomorrowStr;
    });

    // Load from IndexedDB first for instant display
    try {
      const storedData = await getData("sportsData");
      if (storedData && storedData?.data?.matches?.length > 0) {
        const filtered = filterHomeMatches(storedData.data.matches);
        console.log("HomeNew IndexedDB live/today/tomorrow filtered:", filtered.length, "total:", storedData.data.matches.length);
        const transformed = transformMatches(filtered);
        setSportsData(transformed.sort((a, b) => new Date(a.eventDateTime).getTime() - new Date(b.eventDateTime).getTime()));
      }
    } catch (e) { console.error("IndexedDB read error:", e); }

    // Fetch fresh data from API
    try {
      const { status, data: response_users } = await apiGet(apiPath.matchList + `?game_type=all`);
      if (status === 200 && response_users?.status) {
        await setData("sportsData", response_users);
        const matches = response_users?.data?.matches || [];
        const filtered = filterHomeMatches(matches);
        console.log("HomeNew live/today/tomorrow matches:", filtered.length, "total:", matches.length);
        const transformed = transformMatches(filtered);
        setSportsData(transformed.sort((a, b) => new Date(a.eventDateTime).getTime() - new Date(b.eventDateTime).getTime()));
      }
    } catch (err) { console.error("HomeNew fetch error:", err); }
  };

  const handleSportClick = (sportLabel) => {
    if (activeSport === sportLabel) {
      setActiveSport(null); // Deselect
    } else {
      setActiveSport(sportLabel);
    }
  };

  const handleMultiMarket = (eventId) => {
    if (!isEmpty(user)) {
      handelAddMultiMarket(eventId);
    } else {
      navigate("/login");
    }
  };
  useEffect(() => {
    fetchAllSport();
  }, []);

  return (
    <LayoutNew desktopHome>
      <DesktopShell activeNav={desktopActiveNav} onSportSelect={onDesktopSport}>
      {(isDesktop || !isEmpty(user)) && (
        <CurrentNews
          message={messagelist}
          setAnnouncement={setAnnouncement}
        />
      )}
      <div className="home-banner-container" style={{ marginTop: isEmpty(user) ? "55px" : 0 }}>
        {/* Static banner — admin-managed banner (MainBanner) commented out for now */}
        {/* <MainBanner desktop={isDesktop} /> */}
        <img
          src="/banner.jpg"
          alt="banner"
          style={{ width: "100%", height: "auto", display: "block" }}
        />
      </div>
      {/* <GameSliderNew /> */}

      {/* Sports Icons Bar with Search */}
      <style>{`
        .wrap-highlight_list .inppayTitle { display: none !important; }
        @keyframes heartBeat {
          0%   { transform: scale(1.1); }
          50%  { transform: scale(0.8); }
          100% { transform: scale(1.1); }
        }
        @keyframes textColorCycle {
          0%   { color: #ff0; }
          50%  { color: red; }
          100% { color: #ff0; }
        }
      `}</style>
      <div
        className="home-mobile-sports"
        style={{
          display: 'flex',
          alignItems: 'stretch',
          background: 'var(--site-header-gradient)',
          overflowX: 'auto',
          overflowY: 'visible',
          whiteSpace: 'nowrap',
          scrollbarWidth: 'none',
          msOverflowStyle: 'none',
          padding: '0',
          height: '43px',
          marginTop: '0',
        }}
      >
          {/* Aviator Black Box */}
          <div
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: 0,
              cursor: 'pointer',
              flex: '0 0 112.85px',
              backgroundColor: '#000',
              width: '112.85px',
              minWidth: '112.85px',
              maxWidth: '112.85px',
              height: '38px',
              boxSizing: 'border-box',
              overflow: 'hidden',
              position: 'relative',
              margin: '4px 4.7px 0 3.4px',
              borderRadius: '8px 8px 0 0',
            }}
          >
            <div style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              gap: '8px',
              animation: 'heartBeat 1s ease infinite',
            }}>
              <img
                src="/home/aviator.png"
                alt="Vimaan"
                style={{ width: '44px', height: '44px', objectFit: 'contain' }}
              />
              <span style={{ fontSize: '15px', fontWeight: '700', whiteSpace: 'nowrap', animation: 'textColorCycle 1s ease infinite', color: '#ff0' }}>Vimaan</span>
            </div>
          </div>

          {[
            { label: 'Cricket',     icon: '/home/cricket.svg',   gameType: 'cricket' },
            { label: 'Tennis',      icon: '/home/tennis.svg',    gameType: 'tennis' },
            { label: 'Soccer',      icon: '/home/scorrer.svg',   gameType: 'soccer' },
            { label: 'Basketball',  icon: '/home/basket.svg',    gameType: 'basketball' },
            { label: 'Horse',       icon: '/home/horse.svg',     gameType: 'horseracing' },
            { label: 'Lottery',     icon: '/home/lottery.svg',   gameType: 'lottery' },
            { label: 'Live Casino', icon: '/home/livecasno.svg', gameType: 'casino' },
            { label: 'Tips',        icon: '/home/tips.svg',      gameType: 'tips' },
          ].map((sport, i) => {
            const isActive = activeSport === sport.label;
            return (
            <div
              key={i}
              onClick={() => handleSportClick(sport.label)}
              style={{
                display: 'inline-flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '4px 10px',
                cursor: 'pointer',
                color: isActive ? '#fff' : '#000',
                fontSize: '15px',
                fontWeight: isActive ? '700' : '600',
                gap: '8px',
                flexShrink: 0,
              }}
            >
              <img
                src={sport.icon}
                alt={sport.label}
                style={{
                  width: '24px',
                  height: '24px',
                  objectFit: 'contain',
                  filter: isActive ? 'brightness(0) invert(1)' : 'brightness(0)',
                }}
              />
              {sport.label}
            </div>
            );
          })}

        {/* Search icon - Sticky right, full height */}
        <div
          className="home-sports-search"
          style={{ marginLeft: 'auto', flexShrink: 0, position: 'sticky', right: '0', zIndex: 10, display: 'flex', alignItems: 'center', justifyContent: 'center', width: '44px', height: '44px', marginTop: '-4px' }}
          onClick={() => setSearchToogle(true)}
        >
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="11" cy="11" r="8" />
            <line x1="21" y1="21" x2="16.65" y2="16.65" />
          </svg>
        </div>
      </div>

      <section className="home-desktop-highlights home-desktop-only" aria-label="Highlights">
        <h2>Highlights</h2>
        {showHighlightTabs && (
          <div className="desktop-highlight-tabs" role="tablist" aria-label="Highlight sports">
            {["Cricket", "Soccer", "Tennis"].map(sport => (
              <button type="button" role="tab" aria-selected={activeSport === sport} key={sport} onClick={() => selectDesktopSport(sport)}>{sport}</button>
            ))}
          </div>
        )}
        {activeSport !== 'Horse' && (
          <div className="desktop-odds-head" aria-hidden="true"><span /><span>1</span><span>X</span><span>2</span><span /></div>
        )}
      </section>

      {/* In-Play Matches Section */}
      {activeSport && (() => {
        console.log("HomeNew activeSport:", activeSport, "sportsData length:", sportsData.length);
        const sportMap = {
          'Cricket': 'cricket',
          'Tennis': 'tennis',
          'Soccer': 'soccer',
          'Basketball': 'basketball',
          'Horse': 'horseracing',
          'Greyhound': 'greyhound',
        };
        const gameType = sportMap[activeSport];
        if (!gameType) return null;
        const filtered = sportsData.filter(res => res.gameType === gameType);

        // Horse Racing uses the dedicated schedule UI (country tabs + venue list
        // + multi-market pin) instead of the generic odds grid. Matches the
        // exchange reference "Horse Racing Schedule" panel.
        if (activeSport === 'Horse') {
          if (filtered.length === 0) return <div style={{padding:'20px',textAlign:'center',color:'#999'}}>No Horse Racing matches available</div>;
          return <HorseRacingSchedule races={filtered} onAddMultiMarket={handleMultiMarket} />;
        }

        console.log("HomeNew filtered matches for", activeSport, ":", filtered.length, filtered);
        if (filtered.length === 0) return <div style={{padding:'20px',textAlign:'center',color:'#999'}}>No {activeSport} matches available</div>;
        const sportsIdMap = {
          'Cricket': 4,
          'Tennis': 2,
          'Soccer': 1,
          'Basketball': 7522,
          'Horse': 7,
          'Greyhound': 4339,
        };
        return (
          <div className="home-match-list" style={{
            width: '100%',
            maxHeight: '270px',
            overflowY: 'auto',
            overflowX: 'hidden',
          }}>
            <InplayTabs
              type="in_play"
              parlyTab={false}
              data={isDesktop ? filtered.map(item => ({
                ...item,
                desktopMarket: desktopMarkets[`${item.eventId}:${item.marketId}`],
              })) : filtered}
              desktop={isDesktop}
              homeBadges
              handelAddMultiMarket={handleMultiMarket}
              setLoading={() => {}}
              sportsType={activeSport}
              sportsId={sportsIdMap[activeSport]}
            />
          </div>
        );
      })()}

      {/* Casino games section (shared with the In-Play page). On desktop it is
          hidden once an explicit nav sport is selected — then only that sport's
          match list shows. */}
      {!(isDesktop && navSport !== "Home") && (
        <div className="home-casino-section"><CasinoGamesSection /></div>
      )}

      <div className="main" style={{ padding: 0, margin: 0 }}>
        <img
          ref={spinnerRef}
          onClick={() => {
            if (!isEmpty(user)) {
              navigate("/spin-wheel");

            } else {
              navigate("/login");
            }
          }}
          src="/assets/spinner.GIF"
          alt=""
          style={{
            display: 'none',
            position: 'fixed',
            left: `${position.x}px`,
            top: `${position.y}px`,
            cursor: 'grab',
            zIndex: 9999,
            width: '70px',
            height: '70px',
            userSelect: 'none',
            touchAction: 'none'
          }}
          onMouseDown={handleMouseDown}
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
        />


        {/* <div className="tabWrap" >
          {NavDepositWithrawData?.map((item, index) => {
            return (
              <div key={index}
                onClick={() => {
                  // if (isEmpty(user)) {
                  //   withoutLogin();
                  // } else {
                    if (!isEmpty(item?.link)) {
                      navigate(item?.link);
                    } else {
                      setFunc(item?.type);
                    }
                  // }
                }}
                className={`tab-box box ${tabkey == item?.type ? "active" : ""}`}
              >
                <figure>
                  <LazyLoadImage
                    src={ item?.icons}
                    alt=""
                
                  />
                </figure>
                <span>{item?.title}</span>
              </div>
            );
          })}
        </div>   */}
        {/* <div className="gamehall">
          {(() => {
            switch (tabkey) {
              case 'table':
                return <HomeCard type="casino" dataList={DepositWithrawDataArray.filter(obj => obj.key === "table")} className="gT_ld"/>;
              case 'sports':
                return <HomeCard type="casino" dataList={DepositWithrawDataArray.filter(obj => obj.key === "sports")} className="gT_cricket"/>;
              case 'fish':
                return <HomeCard type="casino" dataList={DepositWithrawDataArray.filter(obj => obj.key === "fish")} className="gT_ld"/>;
              case 'slot':
                return <HomeCard type="casino" dataList={DepositWithrawDataArray.filter(obj => obj.key === "slot")} className="gT_ld"/>;                  
              case 'casino':
                return <HomeCard type="casino" dataList={DepositWithrawDataArray.filter(obj => obj.key === "casino")} className="gT_ld"/>;
              case 'arcade':
                return <HomeCard type="casino" dataList={DepositWithrawDataArray.filter(obj => obj.key === "arcade")} className="gT_ld"/>;
              case 'crash':
                return <HomeCard type="casino" dataList={DepositWithrawDataArray.filter(obj => obj.key === "crash")} className=""/>;
              default:
                return null;
            }
          })()}
        {/* {console.log(inplayCountData)} */}
        {/* <HomeList /> */}
        {/* </div> */}


        {/* <GameSlider /> */}
        {/* <SlotSlider /> */}
        {/* <LiveCashino title="Featured Games" /> */}
        {/* <LiveCashino2 title="India Casino" /> */}
      </div>

        {/* Footer links + iOS download — kept outside .main so it also shows in desktop mode (below the cards) */}
        <FooterSection />
      </DesktopShell>
    </LayoutNew>
  );
};

export default HomeNew;